<template>
  <nav>
    <v-toolbar dense :flat="$store.state.darkTheme" app color="appBar" :style="{'z-index': drawer ? 1 : 3}">
      <v-toolbar-side-icon
          
          @click="drawer = !drawer"
          v-if="!softBlock && userInfo && Object.keys(userInfo).length && userInfo.userID && (userInfo.importManager || userInfo.signatureManager || userInfo.outOfOfficeManager || userInfo.selectListManager || userInfo.workflowManager || userInfo.userManager || userInfo.docRepoManager || userInfo.smtpMailboxManager || userInfo.workflowManager || userInfo.fieldsetManager || userInfo.folderManager)"
      ></v-toolbar-side-icon>
      
      <img v-if="!$store.state.darkTheme" src="../../../public/colorFull.svg" width="180px"
           @click="userInfo && (userInfo.userID == 1 || userInfo.userID == 11) ? nav('syncStat') : ''">
      <img v-else src="../../../public/colorFullWhiteText.svg" width="180px"
           @click="userInfo && (userInfo.userID == 1 || userInfo.userID == 11) ? nav('syncStat') : ''">
      
      <v-layout row class="pl-2">
        <v-flex shrink class="py-2">
          <v-divider vertical></v-divider>
        </v-flex>
        <v-flex xs12 class="pl-2" v-if="userInfo">
          <v-layout row align-center v-show="userInfo && typeof userInfo.userID != 'undefined'">
            <!--Dash-->
            <v-flex class="px-1" shrink>
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('dashboard')"
                    slot="activator"
                >
                  <v-badge
                      overlap
                      color="secondary"
                      left
                      class="mt-2"
                  >
                    <template slot="badge">
                      <span class="white--text caption">{{ notificationCount }}</span>
                    </template>
                    <!--<v-icon @click="nav('dashboard')" large color="white" class="nav-item" >dashboard</v-icon>-->
                    <img src="../../../public/icons/dashboard_white.svg" class="nav-item" width="24px">
                  </v-badge>
                </v-btn>
                <span>Dashboard</span>
              </v-tooltip>
            </v-flex>
            <!--SMTP-->
            <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.smtpAddressEnabled === 1)">
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('smtp')"
                    slot="activator"
                >
                  <!--                                    <img src="../../../public/smtp.svg" class="nav-item" width="32px">-->
                  <!--                                    <v-icon large color="white">mail_outline</v-icon>-->
                  <img src="../../../public/smtp_mail_multi.svg" class="nav-item" width="24px"
                       style="height: 24px; width: 24px">
                </v-btn>
                <span>Mail</span>
              </v-tooltip>
            </v-flex>
            
            <!--SMTP Mailboxes-->
            <v-flex class="px-1 pt-1" shrink
                    v-if="!softBlock && userInfo.mailboxes && Array.isArray(userInfo.mailboxes) && userInfo.mailboxes.length">
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('mailboxes')"
                    slot="activator"
                >
                  <img src="../../../public/mailbox_multi.svg" class="nav-item" width="24px"
                       style="height: 24px; width: 24px">
                </v-btn>
                <span>Group Mailboxes</span>
              </v-tooltip>
            </v-flex>
            <!--Office-->
            <!--                        <v-flex class="px-1 pt-1" shrink v-if="intToBool(userInfo.office365Enabled)">-->
            <!--                            <v-tooltip bottom>-->
            <!--                                <v-btn-->
            <!--                                        icon-->
            <!--                                        flat-->
            <!--                                        large-->
            <!--                                        color="white"-->
            <!--                                        class="pa-0 ma-0"-->
            <!--                                        @click="nav('mail')"-->
            <!--                                        slot="activator"-->
            <!--                                >-->
            <!--                                    <img src="../../../public/outlook_32x1.svg" class="nav-item" >-->
            <!--                                </v-btn>-->
            <!--                                <span>Office 365</span>-->
            <!--                            </v-tooltip>-->
            <!--                        </v-flex>-->
            <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.office365Enabled)">
              
              
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                      icon
                      flat
                      color="secondary"
                      class="pa-0 ma-0"
                      @click="nav('mail')"
                      v-on="on"
                  >
                    <img src="../../../public/outlook_32x1.svg" class="nav-item" width="28px">
                    
                    <div style="position: absolute; right: 0; top: -5px"
                         v-if="userInfo.office365Autolink && !userInfo.officeForwarderReady">
                      <v-tooltip right>
                        <template v-slot:activator="{on}">
                          <v-icon small color="amber" v-on="on">
                            warning
                          </v-icon>
                        </template>
                        Warning Office 365 autolink rule has not been setup
                      </v-tooltip>
                    </div>
                  </v-btn>
                </template>
                <span>Office 365</span>
              </v-tooltip>
              <!--                            <v-tooltip bottom>-->
              
              <!--                                <v-btn-->
              <!--                                        icon-->
              <!--                                        flat-->
              <!--                                        large-->
              <!--                                        color="white"-->
              <!--                                        class="pa-0 ma-0"-->
              <!--                                        @click="nav('gmail')"-->
              <!--                                        slot="activator"-->
              <!--                                >-->
              <!--                                    <img src="../../../public/icons/gmail.svg" class="nav-item" style="width: 32px">-->
              <!--                                    <div style="position: absolute; right: 0; top: -12px" v-if="!userInfo.gmailForwarderReady">-->
              <!--                                        <v-tooltip right>-->
              <!--                                            <template v-slot:activator="{on}">-->
              <!--                                                <v-icon small color="amber" v-on="on">-->
              <!--                                                    warning-->
              <!--                                                </v-icon>-->
              <!--                                            </template>-->
              <!--                                            Warning GMail autolink forwarder has not been setup-->
              <!--                                        </v-tooltip>-->
              <!--                                    </div>-->
              <!--                                </v-btn>-->
              <!--                                <span>Gmail</span>-->
              <!--                            </v-tooltip>-->
            </v-flex>
            <!--Zoho-->
            <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.zohoEnabled)">
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('zoho')"
                    slot="activator"
                >
                  <img src="../../../public/zohoLogo.svg" class="nav-item" style="width: 24px">
                </v-btn>
                <span>Zoho Mail</span>
              </v-tooltip>
            </v-flex>
            <!--Gmail-->
            <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.gmailEnabled)">
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('gmail')"
                    slot="activator"
                >
                  <img src="../../../public/icons/gmail.svg" class="nav-item" style="width: 24px">
                  <div style="position: absolute; right: 0; top: -12px" v-if="!userInfo.gmailForwarderReady">
                    <v-tooltip right>
                      <template v-slot:activator="{on}">
                        <v-icon small color="amber" v-on="on">
                          warning
                        </v-icon>
                      </template>
                      Warning GMail autolink forwarder has not been setup
                    </v-tooltip>
                  </div>
                </v-btn>
                <span>Gmail</span>
              </v-tooltip>
            </v-flex>
            <!--Tasks-->
            <v-flex class="px-1" shrink>
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('tasks')"
                    slot="activator"
                >
                  <img src="../../../public/icons/tasks_white.svg" class="nav-item reflow-image" style="max-height: 24px; max-width: 24px">
                </v-btn>
                <span>Tasks</span>
              </v-tooltip>
            </v-flex>
            <!--Folders-->
            <v-flex class="px-1" shrink>
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('folders')"
                    slot="activator"
                >
                  <img src="../../../public/icons/folders.svg" class="nav-item" style="width: 24px">
                </v-btn>
                <span>Folders</span>
              </v-tooltip>
            </v-flex>
            <!--Reports-->
            <v-flex class="px-1" shrink
                    v-if="typeof userInfo.reportsManager != 'undefined' && (intToBool(userInfo.reportsManager)) || intToBool(userInfo.reportsViewer)">
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('reporting')"
                    slot="activator"
                >
                  <img src="../../../public/icons/reports_light.svg" style="width: 24px" class="nav-item"/>
                </v-btn>
                <span>Reports</span>
              </v-tooltip>
            </v-flex>
            
            <!--Calendar View-->
            <v-flex class="px-1 pt-1" shrink v-if="!softBlock && true">
              <v-tooltip bottom>
                <v-btn
                    icon
                    flat
                    color="secondary"
                    class="pa-0 ma-0"
                    @click="nav('calendar')"
                    slot="activator"
                >
                  <img src="../../../public/icons/calendar.svg" class="nav-item" style="width: 24px">
                </v-btn>
                <span>Calendar View</span>
              </v-tooltip>
            </v-flex>
            
            <!--Browse Contacts View-->
            <v-flex class="px-1 pt-1" shrink
                    v-if="!softBlock && userInfo.entityInfo && userInfo.entityInfo.contactsEnabled && !userInfo.contactsDisabled">
              <v-tooltip bottom>
                <template #activator="{on}">
                  <v-btn
                      v-on="on"
                      icon
                      flat
                      color="secondary"
                      class="pa-0 ma-0"
                      @click="nav('contacts')"
                  >
                    <img src="../../../public/contacts.svg" class="nav-item" style="width: 24px">
                  </v-btn>
                </template>
                <span>Browse Contacts</span>
              </v-tooltip>
            </v-flex>
            
            <!--Chats View-->
            <v-flex class="px-1 pt-1" shrink
                    v-if="!softBlock && userInfo.entityInfo && userInfo.entityInfo.contactsEnabled && !userInfo.contactsDisabled">
              <v-tooltip bottom>
                <template #activator="{on}">
                  <v-btn
                      v-on="on"
                      icon
                      flat
                      color="secondary"
                      class="pa-0 ma-0"
                      @click="nav('chat')"
                  >
                    
                    <transition
                        enter-active-class="scale-in-center"
                        leave-active-class="scale-out-center"
                        mode="out-in"
                    >
                      <v-badge
                          overlap
                          color="secondary"
                          left
                          class="mt-2"
                          v-if="unreadChatMessages"
                          :key="unreadChatMessages"
                      >
                        <template slot="badge">
                          <span class="white--text caption">{{ unreadChatMessages }}</span>
                        </template>
                        <!--<v-icon @click="nav('dashboard')" large color="white" class="nav-item" >dashboard</v-icon>-->
                        <img src="../../../public/chat.svg" class="nav-item" style="height: 24px">
                      </v-badge>
                      <img v-else src="../../../public/chat.svg" class="nav-item" style="width: 24px">
                    </transition>
                  </v-btn>
                </template>
                <span>Chat Channels</span>
              </v-tooltip>
            </v-flex>
            
            <v-flex class="pr-1 pl-0 pt-1" shrink v-if="!softBlock && true">
              <v-tooltip bottom>
                <template #activator="{on}">
                  <v-btn
                      v-on="on"
                      icon
                      flat
                      color="secondary"
                      class="pa-0 ma-0"
                      @click="addRepoDocs()"
                  >
                    <v-icon :size="24" color="#ffcb29" class="nav-item">source</v-icon>
                  </v-btn>
                </template>
                <span>Document Store</span>
              </v-tooltip>
            </v-flex>
            
            <template v-if="!softBlock && typeof userInfo.quickTasks != 'undefined' && userInfo.quickTasks.length > 0">
              <v-divider vertical class="my-2"></v-divider>
              
              <v-flex v-if="changingOrder" class="mx-1" xs12>
                <v-progress-circular
                    :size="24"
                    :width="5"
                    color="secondary"
                    indeterminate
                />
              </v-flex>
              <!--Quick Task-->
              <v-flex class="ml-1 smallwhiteScroll" xs12 v-else style="overflow-x: auto">
                <div style="overflow-x: auto" class="smallwhiteScroll">
                  <draggable
                      :list="sortedQuickTasks"
                      group="quickTasks"
                      @start="drag=true"
                      @end="drag=false"
                      @change="log"
                      ghostClass="ghost"
                      class="c-d-flex c-align-center c-justify-start"
                  >
                    <div v-for="qTask in sortedQuickTasks" :key="qTask.id" class="pr-1 c-flex-grow-0">
                      
                      <div class="">
                        <v-menu offset-y bottom center open-on-hover>
                          <template v-slot:activator="{ on }">
                            <v-btn
                                icon
                                flat
                                :color="$store.state.darkTheme ? 'white' : 'black'"
                                class="pa-0 ma-0"
                                @click="quickTaskRun(qTask.config.workflow,qTask.config.folder)"
                                v-on="on"
                            >
                              <v-icon>{{ qTask.config.icon }}</v-icon>
                            </v-btn>
                          </template>
                          <v-card class="white--text grey darken-2 pa-0 ma-0 py-1">
                            <v-layout row align-center class="text-xs-center">
                              <v-flex xs12 class="pr-1 pl-2">
                                {{ qTask.config?.description }}
                              </v-flex>
                              <v-flex shrink>
                                <v-btn
                                    icon
                                    flat
                                    small
                                    color="white"
                                    class="pa-0 ma-0"
                                    @click="editQuickTask = JSON.parse(JSON.stringify(qTask)); showEditQuickTask = true"
                                >
                                  <v-icon small>edit</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex shrink>
                                <v-btn
                                    icon
                                    flat
                                    small
                                    color="red"
                                    class="pa-0 ma-0"
                                    @click="removeQuick(qTask)"
                                >
                                  <v-icon small>close</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-menu>
                      </div>
                    
                    
                    </div>
                  </draggable>
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
      
      <!--Announcement-->
      <!--            <announcement/>-->
      
      <v-tooltip bottom v-if="$store.state.curView === 'app-tasks' && $store.getters['ai/showAiChat']">
        <template #activator="{on}">
          <v-btn icon flat small color="white" class="pa-0 ma-0 mr-1" v-on="on"
                 @click="$store.state.ai.showTaskChat = !$store.state.ai.showTaskChat">
            <img src="/icons/aiLogo.svg" class="nav-item" style="height: 24px">
          </v-btn>
        </template>
        <span>Toggle AI Chat</span>
      </v-tooltip>
      
      <mail-que/>
      
      <support-dialog/>
      
      <div class="mr-2">
        <v-tooltip bottom v-if="userInfo && userInfo.userID">
          <template #activator="{on}">
            <a href="https://tl-app.tasklogix.co.za/#/?link=n40bul" target="_blank">
              <v-btn
                  icon
                  flat
                  class="pa-0 ma-0"
                  @click="$store.state.showChat = !$store.state.showChat"
                  v-on="on"
              >
                <v-icon>chat</v-icon>
              </v-btn>
            </a>
          </template>
          <span>Chat to support</span>
        </v-tooltip>
      </div>
      
      <template v-if="userInfo && typeof userInfo.name != 'undefined'">
        <v-menu offset-x offset-overflow left nudge-left="6">
          <v-avatar
              color="secondary"
              slot="activator"
              :size="35"
              style="cursor: pointer"
              class="pa-0 ma-0"
          >
            <span class="white--text body-2">{{ getInitials(userInfo.name + ' ' + userInfo.surname) }}</span>
            <div v-if="!userInfo.mfaEnabled || !userInfo.pwResetEmail" style="position: absolute; right: 0; top: 0; transform: translate(30%, -30%)">
              <v-icon color="amber">error</v-icon>
            </div>
          </v-avatar>
          <v-card max-height="90vh" class="of-y">
            <v-list dense>
              <template v-for="profile in profiles">
                <v-list-tile
                    v-if="userInfo && userInfo.userProfiles && Array.isArray(userInfo.userProfiles)"
                    avatar
                    :key="profile.userId"
                    @click="gotoProfile(profile)"
                >
                  <v-list-tile-avatar :size="32" :color="profile.active ? 'primary' : null">
                    <v-icon
                        :color="profile.active ? 'white' : 'primary'"
                    >{{ profile.active ? 'person' : 'person_outline' }}
                    </v-icon>
                  </v-list-tile-avatar>
                  
                  <v-list-tile-content :class="{
                                    'font-weight-bold' : profile.active
                                }">
                    <v-list-tile-title v-html="profile.userName"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="profile.entityName"></v-list-tile-sub-title>
                  </v-list-tile-content>
                  
                  <v-list-tile-action>
                    <v-btn
                        v-if="!profile.active"
                        flat icon color="error"
                        small
                        :loading="loadingProfile"
                        :disabled="loadingProfile"
                        @click.stop="removeProfile(profile)"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-btn
                        v-else
                        flat icon color="primary"
                        small
                        @click.stop="addProfileUsername = null; addProfilePassword = null; showAddProfile = true"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
              
              
              <v-divider></v-divider>
              
              <v-list-tile @click="logOff">
                <v-list-tile-action>
                  <v-icon color="primary">exit_to_app</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Sign Out
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile @click="showResetPassword = true">
                <v-list-tile-action>
                  <v-icon color="primary">vpn_key</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Change Password
                </v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile @click="showPwResetEmail = true">
                <v-list-tile-action>
                  <v-icon :color="userInfo.pwResetEmail ? 'primary' : 'amber'" style="position: relative">
                    {{userInfo.pwResetEmail ? 'lock_reset' : 'error'}}
                  </v-icon>
                
                </v-list-tile-action>
                <v-list-tile-content>
                  Update Recovery Email
                </v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile @click="nav('twoFactor')">
                <v-list-tile-action>
                  <v-icon :color="userInfo.mfaEnabled ? 'primary' : 'amber'" style="position: relative">
                    {{userInfo.mfaEnabled ? 'verified_user' : 'error'}}
                  </v-icon>
                
                </v-list-tile-action>
                <v-list-tile-content>
                  MFA Authentication
                </v-list-tile-content>
              </v-list-tile>
              
              <template v-if="userInfo && intToBool(userInfo.gmailEnabled)">
                <v-list-tile v-if="!userInfo.googleSSO" @click="linkGoogleSso">
                  <v-list-tile-action>
                    <img src="../../../public/google_g.svg" class="nav-item" style="width: 24px">
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Link Google SSO
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-else @click="removeGoogleSso">
                  <v-list-tile-action>
                    <img src="../../../public/google_g.svg" class="nav-item" style="width: 24px">
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Remove Google SSO
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              
              <template v-if="userInfo && intToBool(userInfo.office365Enabled)">
                <v-list-tile v-if="!userInfo.microsoftSSO" @click="linkMicrosoftSso">
                  <v-list-tile-action>
                    <img src="../../../public/microsoft_window.svg" class="nav-item" style="width: 24px">
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Link Microsoft SSO
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-else @click="removeMicrosoftSso">
                  <v-list-tile-action>
                    <img src="../../../public/microsoft_window.svg" class="nav-item" style="width: 24px">
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Remove Microsoft SSO
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              
              <v-list-tile v-if="!softBlock" @click="showDigest = true">
                <v-list-tile-action>
                  <v-icon color="primary">mail_outline</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Digest Options
                </v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile v-if="!softBlock && this.$store.getters['userInfo/contactsEnabled']" @click="showAutoRead = true">
                <v-list-tile-action>
                  <v-icon color="primary">mark_chat_read</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Chat Notification Settings
                </v-list-tile-content>
              </v-list-tile>
              
              <v-divider v-if="!softBlock"></v-divider>
              <v-list-tile v-if="!softBlock">
                <v-switch
                    v-model="$store.state.oPlugIgnore"
                    hide-details
                    color="primary"
                    class="pa-0 ma-0"
                    label="Ignore Office Plugin"
                />
              </v-list-tile>
              <v-list-tile v-if="!softBlock" @click="oPlugCopyUrl">
                <v-list-tile-action>
                  <v-icon color="primary">content_copy</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Outlook Plugin URL
                </v-list-tile-content>
              </v-list-tile>
              
              
              
              
              
              <v-divider v-if="!softBlock"></v-divider>
              
              <v-list-tile v-if="!softBlock && intToBool(userInfo.allowOutOfOfficeUpdate)">
                <v-switch
                    v-model="outOfOffice"
                    hide-details
                    color="primary"
                    class="pa-0 ma-0"
                    label="Out of Office"
                    ref="outOfOfficeSwitch"
                    :loading="settingOOO"
                    :disabled="settingOOO"
                />
              </v-list-tile>
              
              <v-list-tile v-if="!softBlock && $store.state.userInfo.userInfo">
                <v-switch
                    v-model="pdfPreview"
                    hide-details
                    color="primary"
                    class="pa-0 ma-0"
                    label="Show PDF Preview"
                    ref="pdfPreview"
                    :loading="settingPdfPreview"
                    :disabled="settingPdfPreview"
                />
              </v-list-tile>
              
              <v-list-tile v-if="!softBlock && userInfo">
                <v-switch
                    v-model="starOnCreate"
                    hide-details
                    color="primary"
                    class="pa-0 ma-0"
                    label="Star on Create Task"
                    :loading="settingStarOnCreate"
                    :disabled="settingStarOnCreate"
                    ref="comSwitch"
                />
              </v-list-tile>
              <v-list-tile v-if="!softBlock && userInfo">
                <v-switch
                    v-model="followOnCreate"
                    hide-details
                    color="primary"
                    class="pa-0 ma-0"
                    label="Follow on Create Task"
                    :loading="settingfollowOnCreate"
                    :disabled="settingfollowOnCreate"
                    ref="comSwitch"
                />
              </v-list-tile>
              <v-divider v-if="!softBlock"></v-divider>
              <!--                            <v-list-tile v-if="typeof this.userInfo.taskView !== 'undefined'">-->
              <!--                                <v-switch-->
              <!--                                        v-model="taskViewVer"-->
              <!--                                        hide-details-->
              <!--                                        color="primary"-->
              <!--                                        class="pa-0 ma-0"-->
              <!--                                        label="Task Split View"-->
              <!--                                        :loading="settingTaskViewVer"-->
              <!--                                        :disabled="settingTaskViewVer"-->
              <!--                                        ref="comSwitch"-->
              <!--                                />-->
              <!--                            </v-list-tile>-->
              <!--                            <v-divider></v-divider>-->
              <v-list-tile @click="resetSyncStatus">
                <v-list-tile-action>
                  <v-icon color="primary">sync</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Reset Local Data
                </v-list-tile-content>
              </v-list-tile>
              <template v-if="!softBlock && userInfo && userInfo.bulkSmsEnabled">
                <v-divider></v-divider>
                
                <v-list-tile @click="showSMSProfile = true">
                  <v-list-tile-action>
                    <v-icon color="primary">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Bulk Sms Credits
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              
              <v-divider v-if="!softBlock"></v-divider>
              <v-divider v-if="!softBlock"></v-divider>
              
              <v-list-tile v-if="!softBlock"
                           @click="copyText(document, `${userInfo.entityInfo.smtpKey}-link@mail.tasklogix.co.za`); $snack.info('Autolink Address Copied')">
                <v-list-tile-action>
                  <v-icon color="primary">content_copy</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Copy Autolink Address
                </v-list-tile-content>
              </v-list-tile>
              
              <template v-if="!softBlock && userInfo && userInfo.smtpAddressEnabled === 1">
                <v-list-tile @click="showSMTPSettings = true">
                  <v-list-tile-action>
                    <img src="../../../public/smtp.svg" class="nav-item" width="18px">
                  </v-list-tile-action>
                  <v-list-tile-content>
                    SMTP Mail Settings
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              
              <v-list-tile v-if="userInfo && intToBool(userInfo.zohoEnabled)" @click="copyZohoWebhookURL">
                <v-list-tile-action>
                  <img src="../../../public/zohoLogo.svg" class="nav-item" style="width: 24px">
                </v-list-tile-action>
                <v-list-tile-content>
                  Copy Zoho Webhook URL
                </v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile v-if="userInfo && intToBool(userInfo.zohoEnabled)" @click="removeZohoAccountStart">
                <v-list-tile-action>
                  <img src="../../../public/zohoLogo.svg" class="nav-item" style="width: 24px">
                </v-list-tile-action>
                <v-list-tile-content>
                  Remove Account
                </v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile v-if="userInfo && intToBool(userInfo.gmailEnabled)" @click="showRemoveGmailAccess = true">
                <v-list-tile-action>
                  <img src="../../../public/icons/gmail.svg" class="nav-item" style="width: 24px">
                </v-list-tile-action>
                <v-list-tile-content>
                  Remove Account
                </v-list-tile-content>
              </v-list-tile>
              
              <v-list-tile v-if="userInfo && intToBool(userInfo.office365Enabled)"
                           @click="showRemoveOfficeAccess = true">
                <v-list-tile-action>
                  <img src="../../../public/outlook_32x1.svg" style="width: 24px"/>
                </v-list-tile-action>
                <v-list-tile-content>
                  Remove Account
                </v-list-tile-content>
              </v-list-tile>
              
              <template v-if="!softBlock && userInfo && intToBool(userInfo.office365Enabled)">
                <v-list-tile @click="showManageSendAs = true">
                  <v-list-tile-action>
                    <img src="../../../public/outlook_32x1.svg" style="width: 24px"/>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Manage Send As
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              
              <v-list-tile v-if="!softBlock && userInfo && intToBool(userInfo.office365Enabled)">
                <v-switch
                    color="primary"
                    class="pa-0 ma-0"
                    label="Office 365 Autolink"
                    v-model="userInfo.office365Autolink"
                    @change="updateO365AutoLink($event)"
                    hide-details
                ></v-switch>
              
              </v-list-tile>
              
              <v-subheader>Theme</v-subheader>
              <v-list-tile v-if="!softBlock && userInfo" class="py-0 my-0">
                
                <div class="c-d-flex c-justify-space-around" style="width: 100%">
                  
                  <v-tooltip top>
                    <template #activator="{on}">
                      <v-btn
                          v-on="on"
                          class="my-0"
                          flat
                          icon
                          :color="$store.state.themePref === 'auto' ? 'secondary' : null"
                          @click="setTheme('auto')"
                      >
                        <v-icon>auto_mode</v-icon>
                      </v-btn>
                    </template>
                    Auto
                  </v-tooltip>
                  
                  <v-tooltip top>
                    <template #activator="{on}">
                      <v-btn
                          v-on="on"
                          class="my-0"
                          flat
                          icon
                          :color="$store.state.themePref === 'light' ? 'secondary' : null"
                          @click="setTheme('light')"
                      >
                        <v-icon>light_mode</v-icon>
                      </v-btn>
                    </template>
                    Light
                  </v-tooltip>
                  
                  <v-tooltip top>
                    <template #activator="{on}">
                      <v-btn
                          v-on="on"
                          class="my-0"
                          flat
                          icon
                          :color="$store.state.themePref === 'dark' ? 'secondary' : null"
                          @click="setTheme('dark')"
                      >
                        <v-icon>dark_mode</v-icon>
                      </v-btn>
                    </template>
                    Dark (Feature Preview)
                  </v-tooltip>
                </div>
              
              
              </v-list-tile>
            
            
            </v-list>
          </v-card>
        </v-menu>
        
        <app-reset-password-dlg
            :show-dialog="showResetPassword"
            title="Reset Password"
            body="Password must include a minimum of 10 characters and have at least one uppercase, lowercase and special character"
            :cancel-button="true"
            :buttons="['Reset Password']"
            :call-backs="[ resetPassword ]"
            @dismiss="showResetPassword = false"
        />
      </template>
    
    
    </v-toolbar>
    
    <v-navigation-drawer
        hide-overlay
        temporary
        v-model="drawer"
        app
        v-if="userInfo && userInfo.userID && (userInfo.importManager || userInfo.signatureManager || userInfo.outOfOfficeManager || userInfo.selectListManager || userInfo.workflowManager || userInfo.userManager || userInfo.docRepoManager || userInfo.smtpMailboxManager || userInfo.workflowManager || userInfo.fieldsetManager || userInfo.folderManager || userInfo.productivityReports || userInfo.taskHeaderReports)"
    >
      <v-toolbar flat class="transparent">
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar color="secondary">
              <v-icon dark>account_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ userInfo.name }} {{ userInfo.surname }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ userInfo.username }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list dense>
        <div>
          <div class="pa-2 greyType--text text--darken-2 caption font-weight-bold">
            Manager Screens
          </div>
        </div>
        <!--Calendar Groups Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.calGroupManager)"
            avatar
            @click="nav('calGroupManager')"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">edit_calendar</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Calendar Groups</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Contact Management-->
        <v-list-tile
            v-if="intToBool(userInfo.contactsManager)"
            avatar
            @click="nav('manageContacts')"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">contact_mail</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Contacts</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Dataset Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.fieldsetManager)"
            avatar
            
            @click="nav('datasetSetManager')"
        >
          <v-list-tile-action :tile="true">
            <img src="../../../public/icons/datasets.svg" style="height: 36px"/>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Datasets</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Document Repository Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.docRepoManager)"
            avatar
            @click="showDocRepoManager()"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">source</v-icon>
            <!--<img src="../../../public/users.svg" class="nav-item" width="32px">-->
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Document Store</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Folder Groups-->
        <v-list-tile
            avatar
            @click="nav('folderManager')"
            v-if="userInfo.folderManager === 1"
        >
          <v-list-tile-action :tile="true">
            <img src="../../../public/icons/user_folder.svg" style="width: 36px"/>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Folder Groups</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Mailbox Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.smtpMailboxManager)"
            avatar
            @click="showMailboxManger()"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">markunread_mailbox</v-icon>
            <!--<img src="../../../public/users.svg" class="nav-item" width="32px">-->
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Group Mailboxes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Out Of Office Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.outOfOfficeManager)"
            avatar
            @click="showOOOManager()"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">emoji_people</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Out Of Office</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <!--Select List Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.selectListManager) || intToBool(userInfo.workflowManager)"
            avatar
            @click="showSelectList"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">list</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Select Lists</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Signature Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.signatureManager)"
            avatar
            @click="showSignatures"
        >
          <v-list-tile-action :tile="true">
            <img src="../../../public/icons/signatures.svg" style="width: 36px"/>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Signatures</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--User Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.userManager || userInfo.workflowManager || userInfo.fieldsetManager || userInfo.folderManager)"
            avatar
            @click="showUserGroupManger()"
        >
          <v-list-tile-action :tile="true">
            <v-icon large class="primary--text">groups</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>User Groups</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--User Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.userManager)"
            avatar
            @click="showUserManger()"
        >
          <v-list-tile-action :tile="true">
            <img src="../../../public/users.svg" style="width: 36px"/>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Workflows Manager-->
        <v-list-tile
            v-if="intToBool(userInfo.workflowManager)"
            avatar
            @click="nav('workflowEditor')"
        >
          <v-list-tile-action :tile="true">
            <img src="../../../public/workflows.svg" class="nav-item" width="32px">
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Workflows</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <div>
          <v-divider></v-divider>
          <div class="pa-2 greyType--text text--darken-2 caption font-weight-bold"
               v-if="userInfo.productivityReports || userInfo.taskHeaderReports">
            Reporting
          </div>
        </div>
        <!--Productivity Reports-->
        <v-list-tile
            avatar
            @click="nav('productivityReports')"
            v-if="typeof userInfo.productivityReports != 'undefined' && intToBool(userInfo.productivityReports)"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">category</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Productivity Reports</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Task Header Report-->
        <v-list-tile
            v-if="typeof userInfo.taskHeaderReports != 'undefined' && userInfo.taskHeaderReports"
            avatar
            @click="nav('taskHeaderReport')"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary" class="nav-item">summarize</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Task Header Report</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <div>
          <v-divider></v-divider>
          <div class="pa-2 greyType--text text--darken-2 caption font-weight-bold"
               v-if="userInfo.importManager || userInfo.tasklogixAdmin">
            Utilities
          </div>
        </div>
        
<!--AI Setup TODO Add Secuity-->
        <v-list-tile
            avatar
            @click="nav('aiAdmin')"
            v-if="isAdmin || userInfo.aiAdmin"
        >
          <v-list-tile-action :tile="true">
            <div style="position: relative">
              <img src="/icons/aiLogo.svg" width="36px" height="36px">
              <v-icon small color="on-surface" style="position: absolute; right: 0; bottom: 0">settings</v-icon>
            </div>
            
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>AI Admin</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <!--Site Config-->
        <v-list-tile
            avatar
            @click="showSiteConfig = true"
            v-if="masterAdmin"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary">settings</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Entity Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--Importer-->
        <v-list-tile
            avatar
            @click="showImporter = true"
            v-if="userInfo && typeof userInfo.importManager != 'undefined' && intToBool(userInfo.importManager)"
        >
          <v-list-tile-action :tile="true">
            <img src="../../../public/icons/import.svg" style="width: 36px"/>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Imports</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile
            avatar
            @click="showBilling = true"
            v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin"
        >
          <v-list-tile-action :tile="true">
            <v-icon color="primary" large>shopping_cart</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Billing Manager</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
            avatar
            @click="showActiveUsers = true"
            v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin"
        >
          <v-list-tile-action :tile="true">
            <v-icon color="primary" large>trending_up</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Active Users</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
            avatar
            @click="showImpersonationLog = true"
            v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin"
        >
          <v-list-tile-action :tile="true">
            <v-icon color="primary" large>security</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Impersonation Log</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <!--Site Config-->
        <v-list-tile
            avatar
            @click="rsumUpdate()"
            v-if="userInfo.entityID === 97 && (masterAdmin || userInfo.userID === 2162)"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary">settings</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>RSUM Update</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-list-tile
            avatar
            @click="datasetUpdater()"
            v-if="masterAdmin"
        >
          <v-list-tile-action :tile="true">
            <v-icon large color="primary">settings</v-icon>
          </v-list-tile-action>
          
          <v-list-tile-content>
            <v-list-tile-title>Dataset Bulk Update</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    
    
    <app-import-wizard
        v-if="userInfo && typeof userInfo.importManager != 'undefined' && intToBool(userInfo.importManager) && showImporter"
        :user-info="userInfo"
        :show-dialog="showImporter"
        @dismiss="showImporter = false"
    />
    
    <app-input-dlg
        :show-dialog="showRemoveGmailAccess"
        title="Remove Gmail Account"
        body="This will remove access to your GMail account and delete your access token."
        :cancel-button="true"
        :show-input-box="false"
        :buttons="['Remove']"
        :call-backs="[ removeGmailAccess ]"
        @dismiss="showRemoveGmailAccess = false"
    />
    
    <app-input-dlg
        :show-dialog="showRemoveGmailAccess"
        title="Remove Gmail Account"
        body="This will remove access to your GMail account and delete your access token."
        :cancel-button="true"
        :show-input-box="false"
        :buttons="['Remove']"
        :call-backs="[ removeGmailAccess ]"
        @dismiss="showRemoveGmailAccess = false"
    />
    <app-input-dlg
        :show-dialog="showRemoveOfficeAccess"
        title="Remove Office Account"
        body="This will remove access to your Office account and delete your access token."
        :cancel-button="true"
        :show-input-box="false"
        :buttons="['Remove']"
        :call-backs="[ removeOfficeAccess ]"
        @dismiss="showRemoveOfficeAccess = false"
    />
    <app-select-list-manager
        v-if="userInfo && (intToBool(userInfo.selectListManager) || intToBool(userInfo.workflowManager))"
        :show-manager="showSelectLists"
        :selectable="false"
        :select-lists="selectLists"
        :self-load="true"
        :user-info="userInfo"
        @setSelectLists="selectLists = $event"
        @dismiss="showSelectLists = false"
    />
    <app-out-of-office-manager
        v-if="userInfo && showOutOfOfficeManager && intToBool(userInfo.outOfOfficeManager)"
        :user-info="userInfo"
        :show-manager="showOutOfOfficeManager"
        @dismiss="showOutOfOfficeManager = false"
    />
    
    <s-m-s-profile
        :user-info="userInfo"
        v-model="showSMSProfile"
    />
    
    <app-input-dlg
        v-if="showSMTPSettings"
        :show-dialog="showSMTPSettings"
        title="Configure SMTP"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="showSMTPSettings = false"
        :body-padding="false"
        :width="700"
    >
      <template slot="body">
        <div class="pa-2">
          <configure-smtp
              :user-info="userInfo"
          />
        </div>
      </template>
    </app-input-dlg>
    
    <digest-dlg
        v-if="showDigest"
        v-model="showDigest"
    />
    
    <app-input-dlg
        :show-dialog="showEditQuickTask"
        title="Edit Task Shortcut"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="showEditQuickTask = false"
        :body-padding="false"
        v-if="showEditQuickTask"
    >
      <template slot="body">
        <div class="pa-2" v-if="showEditQuickTask">
          <div :class="topicClass">
            <div :class="headingClass">
              Task Shortcut Description:
            </div>
            <div :class="itemClass">
              <v-text-field
                  label="Description"
                  single-line
                  color="primary"
                  append-outer-icon="save"
                  hide-details
                  style="width: 100%"
                  class="pa-0 ma-0"
                  ref="fieldDescription"
                  v-model="editQuickTask.config.description"
              ></v-text-field>
            </div>
          </div>
          <div :class="topicClass">
            <div :class="headingClass">
              Task Shortcut Icon:
            </div>
            <v-menu bottom offset-y lazy v-model="qtiMenue" :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <div :class="itemClass" class="text-xs-center" v-on="on">
                  <div class="text-xs-center">
                    <v-btn
                        large
                        icon
                        class="pa-0 ma-0"
                        color="primary"
                        flat
                    >
                      <v-icon large>{{ editQuickTask.config.icon }}</v-icon>
                    </v-btn>
                  </div>
                  <div class="text-xs-center caption greyType--text">
                    {{ editQuickTask.config.icon }}
                  </div>
                </div>
              </template>
              
              <v-card class="scrollable" style="max-width: 400px">
                <div class="pa-1">
                  <v-text-field
                      label="Filter Icons"
                      single-line
                      clearable
                      prepend-icon="search"
                      color="primary"
                      flat
                      :hide-details="true"
                      v-model="qtiFilterString"
                      class="pa-0 ma-0"
                  ></v-text-field>
                </div>
                
                <v-layout row wrap v-if="qtiMenue" class="scrollable" style="max-height: 300px;">
                  <v-flex shrink
                          v-for="viewIcon in qtiFilterString == null || qtiFilterString === '' ? icons : icons.filter(obj => obj.toLowerCase().includes(qtiFilterString.toLowerCase()))"
                          class="text-xs-center pa-2 hover-item"
                          :key="viewIcon"
                          style="border-radius: 3px"
                  >
                    <v-icon
                        large
                        @click="editQuickTask.config.icon = viewIcon; qtiMenue = false"
                        style="cursor: pointer"
                    >
                      {{ viewIcon }}
                    </v-icon>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-menu>
          </div>
        </div>
      </template>
      <template slot="actions">
        <v-btn
            small
            outline
            color="secondary"
            class="px-2 py-0 ma-0 mx-2"
            :disabled="editingQuickTask"
            @click="showEditQuickTask = false"
        >
          Cancel
        </v-btn>
        
        <v-btn
            small
            color="secondary"
            class="px-2 py-0 ma-0"
            :disabled="blankString(editQuickTask.config?.description) || editingQuickTask"
            :loading="editingQuickTask"
            @click="updateQuickTask"
        >
          Update Task Shortcut
        </v-btn>
      </template>
    </app-input-dlg>
    
    <office-send-as
        v-if="userInfo && userInfo.userID && showManageSendAs"
        :user-id="userInfo.userID"
        :shown.sync="showManageSendAs"
    ></office-send-as>
    
    <billing-manager
        v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin && showBilling"
        :show.sync="showBilling"
    ></billing-manager>

    <active-users
        v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin && showActiveUsers"
        :show.sync="showActiveUsers"
        :user-info="userInfo"
    ></active-users>

    <impersonation-log
        v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin && showImpersonationLog"
        :show.sync="showImpersonationLog"
    ></impersonation-log>
    
    <app-input-dlg
        v-if="showAddProfile"
        :show-dialog="showAddProfile"
        title="Add Tasklogix Profile"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="showAddProfile = false"
        :width="400"
    >
      <template slot="body">
        <v-form v-if="showAddProfile" class="px3" ref="addProfile" v-model="addProfileReady">
          <v-text-field
              append-icon="person_add"
              :rules="[rules.required]"
              @click:append="showPassword = !showPassword"
              label="Username"
              single-line
              v-model="addProfileUsername"
              color="primary"
              style="width: 100%"
              class="ma-0 pa-0"
              autofocus
          ></v-text-field>
          <v-text-field
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              label="Password"
              single-line
              v-model="addProfilePassword"
              color="primary"
              style="width: 100%"
              class="ma-0 pa-0"
          ></v-text-field>
        </v-form>
      </template>
      
      <template slot="actions">
        <v-btn
            small
            outline
            color="secondary"
            class="px-2 py-0 ma-0 mx-2"
            :disabled="loadingProfile"
            @click="showAddProfile = false"
        >
          Cancel
        </v-btn>
        
        <v-btn
            small
            color="secondary"
            class="px-2 py-0 ma-0"
            :disabled="!addProfileReady || loadingProfile"
            :loading="loadingProfile"
            @click="addProfile"
        >
          Add Profile
        </v-btn>
      </template>
    </app-input-dlg>
    
    
    <site-settings
        v-if="showSiteConfig"
        :shown.sync="showSiteConfig"
    />
    
    <app-input-dlg
        v-if="showPwResetEmail"
        :show-dialog="showPwResetEmail"
        title="Update password recovery email"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="showPwResetEmail = false"
        :width="400"
    >
      <template slot="body">
        
        <div class="body-2 pb-3">
          Enter your recovery email address below.<br/><br/>We will use this address to send you a link to reset your password if needed.
        </div>
        
        <v-text-field
            prepend-icon="email"
            :rules="[rules.required, emailValidation]"
            label="Email address"
            single-line
            v-model="pwResetEmailValue"
            color="primary"
            style="width: 100%"
            class="ma-0 pa-0"
            autofocus
        ></v-text-field>
      </template>
      
      <template slot="actions">
        <v-btn
            small
            outline
            color="secondary"
            class="px-2 py-0 ma-0 mx-2"
            :disabled="settingPwResetEmail"
            @click="showPwResetEmail = false"
        >
          Cancel
        </v-btn>
        
        <v-btn
            small
            color="secondary"
            class="px-2 py-0 ma-0"
            :disabled="emailValidation(pwResetEmailValue) !== true || settingPwResetEmail"
            :loading="settingPwResetEmail"
            @click="setPwResetEmail"
        >
          Update Recovery Email Address
        </v-btn>
      </template>
    </app-input-dlg>
    
    <auto-read-dlg :shown.sync="showAutoRead"/>
    
    
    <app-input-dlg
        v-if="!!zohoCopyTokens && userInfo.zohoEnabled"
        :show-dialog="!!zohoCopyTokens"
        title="Select Zoho Account"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="zohoCopyTokens = null"
        :width="400"
    >
      <template slot="body">
        
        <div class="body-2 pb-3">
          Select the Zoho account you would like to copy the webhook url for.
        </div>
        
        <div class="c-d-flex c-align-center" v-for="{id, displayName, primary, zuid} in zohoCopyTokens" :key="id">
          <div>
            <img src="../../../public/zohoLogo.svg" class="nav-item" style="width: 24px">
          </div>
          <div class="c-flex-grow-1 px-3">
            <div class="subheading">
              {{displayName}}
            </div>
            <div class="caption greyType--text">
              {{primary}}
            </div>
          </div>
          <div>
            <v-btn icon flat color="primary" @click="copyZohoWebhookURLRun(zuid)"><v-icon color="primary">content_copy</v-icon></v-btn>
          </div>
        </div>
        
        
      </template>
      
      <template slot="actions">
        <v-btn
            small
            outline
            color="secondary"
            class="px-2 py-0 ma-0 mx-2"
            @click="zohoCopyTokens = null"
        >
          Done
        </v-btn>
      </template>
    </app-input-dlg>
    
    <app-input-dlg
        v-if="!!zohoRemoveTokens && userInfo.zohoEnabled"
        :show-dialog="!!zohoRemoveTokens"
        title="Remove Zoho Account"
        :cancel-button="true"
        :show-input-box="false"
        @dismiss="zohoRemoveTokens = null"
        :width="400"
    >
      <template slot="body">
        
        <div class="body-2 pb-3">
          Select the Zoho account you would like to remove.
        </div>
        
        <div class="c-d-flex c-align-center" v-for="{id, displayName, primary} in zohoRemoveTokens" :key="id">
          <div>
            <img src="../../../public/zohoLogo.svg" class="nav-item" style="width: 24px">
          </div>
          <div class="c-flex-grow-1 px-3">
            <div class="subheading">
              {{displayName}}
            </div>
            <div class="caption greyType--text">
              {{primary}}
            </div>
          </div>
          <div>
            <v-btn icon flat color="error" @click="removeZohoWebhookURLRun(id)"><v-icon color="error">delete</v-icon></v-btn>
          </div>
        </div>
      
      
      </template>
      
      <template slot="actions">
        <v-btn
            small
            outline
            color="secondary"
            class="px-2 py-0 ma-0 mx-2"
            @click="zohoCopyTokens = null"
        >
          Done
        </v-btn>
      </template>
    </app-input-dlg>
  </nav>
</template>

<script>

import {eventBus} from '../../main';
import {codeBaseMixin} from '../../codeBaseMixin';

import ImportWizard from '../../Admin/ImporterV2/ImportWizard'
import ResetPasswordDlg from "./ResetPasswordDlg";
import InputDlg from '../General/InputDlg'
import SelectListManager from "./SelectListManager";
import OutOfOfficeManager from "../../Admin/Out Of Office/OutOfOfficeManager";
import SMSProfile
  from "../../Tasks/TaskView/components/TaskViewDetail/Components/FieldTypeComponents/SMS Components/SMSProfile";
import draggable from 'vuedraggable';
import {arrSplice, copyText, validationRules} from "../../codeFunctions";
import ConfigureSmtp from "../../Mail/SMTP/Configure Smtp/ConfigureSmtp";
import SupportDialog from "./SupportDialog";
import Announcement from "@/Announcemnts/Announcement";
import userInfo from "@/Store/userInfo/userInfo";
import {mapActions, mapGetters} from "vuex";
import DigestDlg from "@/components/General/DigestDlg";
import OfficeSendAs from "@/components/General/OfficeSendAs/OfficeSendAs";
import BillingManager from "@/Admin/Billing Manager/BillingManager.vue";
import billingManager from "@/Admin/Billing Manager/BillingManager.vue";
import ActiveUsers from "@/Admin/Active Users/ActiveUsers.vue";
import ImpersonationLog from "@/Admin/Impersonation Log/ImpersonationLog.vue";
import AppBrowseContacts from "@/contacts/AppBrowseContacts.vue";
import AppCreateLinkContact from "@/contacts/AppCreateLinkContact.vue";
import SiteSettings from "@/components/General/SiteSettings/SiteSettings.vue";
import {dbGlobalMethods} from "@/localDBFunction";
import {serverAddress} from "@/axiosRequest";
import {token} from "@/tokenManSite";
import AutoReadDlg from "@/AutoRead/AutoReadDlg.vue";
import MailQue from "@/components/General/MailQue.vue";

const icons = ['3d_rotation', 'ac_unit', 'access_alarm', 'access_alarms', 'access_time', 'accessibility', 'accessible', 'account_balance', 'account_balance_wallet', 'account_box', 'account_circle', 'adb', 'add', 'add_a_photo', 'add_alarm', 'add_alert', 'add_box', 'add_circle', 'add_circle_outline', 'add_location', 'add_shopping_cart', 'add_to_photos', 'add_to_queue', 'adjust', 'airline_seat_flat', 'airline_seat_flat_angled', 'airline_seat_individual_suite', 'airline_seat_legroom_extra', 'airline_seat_legroom_normal', 'airline_seat_legroom_reduced', 'airline_seat_recline_extra', 'airline_seat_recline_normal', 'airplanemode_active', 'airplanemode_inactive', 'airplay', 'airport_shuttle', 'alarm', 'alarm_add', 'alarm_off', 'alarm_on', 'album', 'all_inclusive', 'all_out', 'android', 'announcement', 'apps', 'archive', 'arrow_back', 'arrow_downward', 'arrow_drop_down', 'arrow_drop_down_circle', 'arrow_drop_up', 'arrow_forward', 'arrow_upward', 'art_track', 'aspect_ratio', 'assessment', 'assignment', 'assignment_ind', 'assignment_late', 'assignment_return', 'assignment_returned', 'assignment_turned_in', 'assistant', 'assistant_photo', 'attach_file', 'attach_money', 'attachment', 'audiotrack', 'autorenew', 'av_timer', 'backspace', 'backup', 'battery_alert', 'battery_charging_full', 'battery_full', 'battery_std', 'battery_unknown', 'beach_access', 'beenhere', 'block', 'bluetooth', 'bluetooth_audio', 'bluetooth_connected', 'bluetooth_disabled', 'bluetooth_searching', 'blur_circular', 'blur_linear', 'blur_off', 'blur_on', 'book', 'bookmark', 'bookmark_border', 'border_all', 'border_bottom', 'border_clear', 'border_color', 'border_horizontal', 'border_inner', 'border_left', 'border_outer', 'border_right', 'border_style', 'border_top', 'border_vertical', 'branding_watermark', 'brightness_1', 'brightness_2', 'brightness_3', 'brightness_4', 'brightness_5', 'brightness_6', 'brightness_7', 'brightness_auto', 'brightness_high', 'brightness_low', 'brightness_medium', 'broken_image', 'brush', 'bubble_chart', 'bug_report', 'build', 'burst_mode', 'business', 'business_center', 'cached', 'cake', 'call', 'call_end', 'call_made', 'call_merge', 'call_missed', 'call_missed_outgoing', 'call_received', 'call_split', 'call_to_action', 'camera', 'camera_alt', 'camera_enhance', 'camera_front', 'camera_rear', 'camera_roll', 'cancel', 'card_giftcard', 'card_membership', 'card_travel', 'casino', 'cast', 'cast_connected', 'center_focus_strong', 'center_focus_weak', 'change_history', 'chat', 'chat_bubble', 'chat_bubble_outline', 'check', 'check_box', 'check_box_outline_blank', 'check_circle', 'chevron_left', 'chevron_right', 'child_care', 'child_friendly', 'chrome_reader_mode', 'class', 'clear', 'clear_all', 'close', 'closed_caption', 'cloud', 'cloud_circle', 'cloud_done', 'cloud_download', 'cloud_off', 'cloud_queue', 'cloud_upload', 'code', 'collections', 'collections_bookmark', 'color_lens', 'colorize', 'comment', 'compare', 'compare_arrows', 'computer', 'confirmation_number', 'contact_mail', 'contact_phone', 'contacts', 'content_copy', 'content_cut', 'content_paste', 'control_point', 'control_point_duplicate', 'copyright', 'create', 'create_new_folder', 'credit_card', 'crop', 'crop_16_9', 'crop_3_2', 'crop_5_4', 'crop_7_5', 'crop_din', 'crop_free', 'crop_landscape', 'crop_original', 'crop_portrait', 'crop_rotate', 'crop_square', 'dashboard', 'data_usage', 'date_range', 'dehaze', 'delete', 'delete_forever', 'delete_sweep', 'description', 'desktop_mac', 'desktop_windows', 'details', 'developer_board', 'developer_mode', 'device_hub', 'devices', 'devices_other', 'dialer_sip', 'dialpad', 'directions', 'directions_bike', 'directions_boat', 'directions_bus', 'directions_car', 'directions_railway', 'directions_run', 'directions_subway', 'directions_transit', 'directions_walk', 'disc_full', 'dns', 'do_not_disturb', 'do_not_disturb_alt', 'do_not_disturb_off', 'do_not_disturb_on', 'dock', 'domain', 'done', 'done_all', 'donut_large', 'donut_small', 'drafts', 'drag_handle', 'drive_eta', 'dvr', 'edit', 'edit_location', 'eject', 'email', 'enhanced_encryption', 'equalizer', 'error', 'error_outline', 'euro_symbol', 'ev_station', 'event', 'event_available', 'event_busy', 'event_note', 'event_seat', 'exit_to_app', 'expand_less', 'expand_more', 'explicit', 'explore', 'exposure', 'exposure_neg_1', 'exposure_neg_2', 'exposure_plus_1', 'exposure_plus_2', 'exposure_zero', 'extension', 'face', 'fast_forward', 'fast_rewind', 'favorite', 'favorite_border', 'featured_play_list', 'featured_video', 'feedback', 'fiber_dvr', 'fiber_manual_record', 'fiber_new', 'fiber_pin', 'fiber_smart_record', 'file_download', 'file_upload', 'filter', 'filter_1', 'filter_2', 'filter_3', 'filter_4', 'filter_5', 'filter_6', 'filter_7', 'filter_8', 'filter_9', 'filter_9_plus', 'filter_b_and_w', 'filter_center_focus', 'filter_drama', 'filter_frames', 'filter_hdr', 'filter_list', 'filter_none', 'filter_tilt_shift', 'filter_vintage', 'find_in_page', 'find_replace', 'fingerprint', 'first_page', 'fitness_center', 'flag', 'flare', 'flash_auto', 'flash_off', 'flash_on', 'flight', 'flight_land', 'flight_takeoff', 'flip', 'flip_to_back', 'flip_to_front', 'folder', 'folder_open', 'folder_shared', 'folder_special', 'font_download', 'format_align_center', 'format_align_justify', 'format_align_left', 'format_align_right', 'format_bold', 'format_clear', 'format_color_fill', 'format_color_reset', 'format_color_text', 'format_indent_decrease', 'format_indent_increase', 'format_italic', 'format_line_spacing', 'format_list_bulleted', 'format_list_numbered', 'format_paint', 'format_quote', 'format_shapes', 'format_size', 'format_strikethrough', 'format_textdirection_l_to_r', 'format_textdirection_r_to_l', 'format_underlined', 'forum', 'forward', 'forward_10', 'forward_30', 'forward_5', 'free_breakfast', 'fullscreen', 'fullscreen_exit', 'functions', 'g_translate', 'gamepad', 'games', 'gavel', 'gesture', 'get_app', 'gif', 'golf_course', 'gps_fixed', 'gps_not_fixed', 'gps_off', 'grade', 'gradient', 'grain', 'graphic_eq', 'grid_off', 'grid_on', 'group', 'group_add', 'group_work', 'hd', 'hdr_off', 'hdr_on', 'hdr_strong', 'hdr_weak', 'headset', 'headset_mic', 'healing', 'hearing', 'help', 'help_outline', 'high_quality', 'highlight', 'highlight_off', 'history', 'home', 'hot_tub', 'hotel', 'hourglass_empty', 'hourglass_full', 'http', 'https', 'image', 'image_aspect_ratio', 'import_contacts', 'import_export', 'important_devices', 'inbox', 'indeterminate_check_box', 'info', 'info_outline', 'input', 'insert_chart', 'insert_comment', 'insert_drive_file', 'insert_emoticon', 'insert_invitation', 'insert_link', 'insert_photo', 'invert_colors', 'invert_colors_off', 'iso', 'keyboard', 'keyboard_arrow_down', 'keyboard_arrow_left', 'keyboard_arrow_right', 'keyboard_arrow_up', 'keyboard_backspace', 'keyboard_capslock', 'keyboard_hide', 'keyboard_return', 'keyboard_tab', 'keyboard_voice', 'kitchen', 'label', 'label_outline', 'landscape', 'language', 'laptop', 'laptop_chromebook', 'laptop_mac', 'laptop_windows', 'last_page', 'launch', 'layers', 'layers_clear', 'leak_add', 'leak_remove', 'lens', 'library_add', 'library_books', 'library_music', 'lightbulb_outline', 'line_style', 'line_weight', 'linear_scale', 'link', 'linked_camera', 'list', 'live_help', 'live_tv', 'local_activity', 'local_airport', 'local_atm', 'local_bar', 'local_cafe', 'local_car_wash', 'local_convenience_store', 'local_dining', 'local_drink', 'local_florist', 'local_gas_station', 'local_grocery_store', 'local_hospital', 'local_hotel', 'local_laundry_service', 'local_library', 'local_mall', 'local_movies', 'local_offer', 'local_parking', 'local_pharmacy', 'local_phone', 'local_pizza', 'local_play', 'local_post_office', 'local_printshop', 'local_see', 'local_shipping', 'local_taxi', 'location_city', 'location_disabled', 'location_off', 'location_on', 'location_searching', 'lock', 'lock_open', 'lock_outline', 'looks', 'looks_3', 'looks_4', 'looks_5', 'looks_6', 'looks_one', 'looks_two', 'loop', 'loupe', 'low_priority', 'loyalty', 'mail', 'mail_outline', 'map', 'markunread', 'markunread_mailbox', 'memory', 'menu', 'merge_type', 'message', 'mic', 'mic_none', 'mic_off', 'mms', 'mode_comment', 'mode_edit', 'monetization_on', 'money_off', 'monochrome_photos', 'mood', 'mood_bad', 'more', 'more_horiz', 'more_vert', 'motorcycle', 'mouse', 'move_to_inbox', 'movie', 'movie_creation', 'movie_filter', 'multiline_chart', 'music_note', 'music_video', 'my_location', 'nature', 'nature_people', 'navigate_before', 'navigate_next', 'navigation', 'near_me', 'network_cell', 'network_check', 'network_locked', 'network_wifi', 'new_releases', 'next_week', 'nfc', 'no_encryption', 'no_sim', 'not_interested', 'note', 'note_add', 'notifications', 'notifications_active', 'notifications_none', 'notifications_off', 'notifications_paused', 'offline_pin', 'ondemand_video', 'opacity', 'open_in_browser', 'open_in_new', 'open_with', 'pages', 'pageview', 'palette', 'pan_tool', 'panorama', 'panorama_fish_eye', 'panorama_horizontal', 'panorama_vertical', 'panorama_wide_angle', 'party_mode', 'pause', 'pause_circle_filled', 'pause_circle_outline', 'payment', 'people', 'people_outline', 'perm_camera_mic', 'perm_contact_calendar', 'perm_data_setting', 'perm_device_information', 'perm_identity', 'perm_media', 'perm_phone_msg', 'perm_scan_wifi', 'person', 'person_add', 'person_outline', 'person_pin', 'person_pin_circle', 'personal_video', 'pets', 'phone', 'phone_android', 'phone_bluetooth_speaker', 'phone_forwarded', 'phone_in_talk', 'phone_iphone', 'phone_locked', 'phone_missed', 'phone_paused', 'phonelink', 'phonelink_erase', 'phonelink_lock', 'phonelink_off', 'phonelink_ring', 'phonelink_setup', 'photo', 'photo_album', 'photo_camera', 'photo_filter', 'photo_library', 'photo_size_select_actual', 'photo_size_select_large', 'photo_size_select_small', 'picture_as_pdf', 'picture_in_picture', 'picture_in_picture_alt', 'pie_chart', 'pie_chart_outlined', 'pin_drop', 'place', 'play_arrow', 'play_circle_filled', 'play_circle_outline', 'play_for_work', 'playlist_add', 'playlist_add_check', 'playlist_play', 'plus_one', 'poll', 'polymer', 'pool', 'portable_wifi_off', 'portrait', 'power', 'power_input', 'power_settings_new', 'pregnant_woman', 'present_to_all', 'print', 'priority_high', 'public', 'publish', 'query_builder', 'question_answer', 'queue', 'queue_music', 'queue_play_next', 'radio', 'radio_button_checked', 'radio_button_unchecked', 'rate_review', 'receipt', 'recent_actors', 'record_voice_over', 'redeem', 'redo', 'refresh', 'remove', 'remove_circle', 'remove_circle_outline', 'remove_from_queue', 'remove_red_eye', 'remove_shopping_cart', 'reorder', 'repeat', 'repeat_one', 'replay', 'replay_10', 'replay_30', 'replay_5', 'reply', 'reply_all', 'report', 'report_problem', 'restaurant', 'restaurant_menu', 'restore', 'restore_page', 'ring_volume', 'room', 'room_service', 'rotate_90_degrees_ccw', 'rotate_left', 'rotate_right', 'rounded_corner', 'router', 'rowing', 'rss_feed', 'rv_hookup', 'satellite', 'save', 'scanner', 'schedule', 'school', 'screen_lock_landscape', 'screen_lock_portrait', 'screen_lock_rotation', 'screen_rotation', 'screen_share', 'sd_card', 'sd_storage', 'search', 'security', 'select_all', 'send', 'sentiment_dissatisfied', 'sentiment_neutral', 'sentiment_satisfied', 'sentiment_very_dissatisfied', 'sentiment_very_satisfied', 'settings', 'settings_applications', 'settings_backup_restore', 'settings_bluetooth', 'settings_brightness', 'settings_cell', 'settings_ethernet', 'settings_input_antenna', 'settings_input_component', 'settings_input_composite', 'settings_input_hdmi', 'settings_input_svideo', 'settings_overscan', 'settings_phone', 'settings_power', 'settings_remote', 'settings_system_daydream', 'settings_voice', 'share', 'shop', 'shop_two', 'shopping_basket', 'shopping_cart', 'short_text', 'show_chart', 'shuffle', 'signal_cellular_4_bar', 'signal_cellular_connected_no_internet_4_bar', 'signal_cellular_no_sim', 'signal_cellular_null', 'signal_cellular_off', 'signal_wifi_4_bar', 'signal_wifi_4_bar_lock', 'signal_wifi_off', 'sim_card', 'sim_card_alert', 'skip_next', 'skip_previous', 'slideshow', 'slow_motion_video', 'smartphone', 'smoke_free', 'smoking_rooms', 'sms', 'sms_failed', 'snooze', 'sort', 'sort_by_alpha', 'spa', 'space_bar', 'speaker', 'speaker_group', 'speaker_notes', 'speaker_notes_off', 'speaker_phone', 'spellcheck', 'star', 'star_border', 'star_half', 'stars', 'stay_current_landscape', 'stay_current_portrait', 'stay_primary_landscape', 'stay_primary_portrait', 'stop', 'stop_screen_share', 'storage', 'store', 'store_mall_directory', 'straighten', 'streetview', 'strikethrough_s', 'style', 'subdirectory_arrow_left', 'subdirectory_arrow_right', 'subject', 'subscriptions', 'subtitles', 'subway', 'supervisor_account', 'surround_sound', 'swap_calls', 'swap_horiz', 'swap_vert', 'swap_vertical_circle', 'switch_camera', 'switch_video', 'sync', 'sync_disabled', 'sync_problem', 'system_update', 'system_update_alt', 'tab', 'tab_unselected', 'tablet', 'tablet_android', 'tablet_mac', 'tag_faces', 'tap_and_play', 'terrain', 'text_fields', 'text_format', 'textsms', 'texture', 'theaters', 'thumb_down', 'thumb_up', 'thumbs_up_down', 'time_to_leave', 'timelapse', 'timeline', 'timer', 'timer_10', 'timer_3', 'timer_off', 'title', 'toc', 'today', 'toll', 'tonality', 'touch_app', 'toys', 'track_changes', 'traffic', 'train', 'tram', 'transfer_within_a_station', 'transform', 'translate', 'trending_down', 'trending_flat', 'trending_up', 'tune', 'turned_in', 'turned_in_not', 'tv', 'unarchive', 'undo', 'unfold_less', 'unfold_more', 'update', 'usb', 'verified_user', 'vertical_align_bottom', 'vertical_align_center', 'vertical_align_top', 'vibration', 'video_call', 'video_label', 'video_library', 'videocam', 'videocam_off', 'videogame_asset', 'view_agenda', 'view_array', 'view_carousel', 'view_column', 'view_comfy', 'view_compact', 'view_day', 'view_headline', 'view_list', 'view_module', 'view_quilt', 'view_stream', 'view_week', 'vignette', 'visibility', 'visibility_off', 'voice_chat', 'voicemail', 'volume_down', 'volume_mute', 'volume_off', 'volume_up', 'vpn_key', 'vpn_lock', 'wallpaper', 'warning', 'watch', 'watch_later', 'wb_auto', 'wb_cloudy', 'wb_incandescent', 'wb_iridescent', 'wb_sunny', 'wc', 'web', 'web_asset', 'weekend', 'whatshot', 'widgets', 'wifi', 'wifi_lock', 'wifi_tethering', 'work', 'wrap_text', 'youtube_searched_for', 'zoom_in', 'zoom_out', 'zoom_out_map'];

export default {
  components: {
    MailQue,
    AutoReadDlg,
    SiteSettings,
    AppCreateLinkContact,
    AppBrowseContacts,
    BillingManager,
    ActiveUsers,
    ImpersonationLog,
    OfficeSendAs,
    DigestDlg,
    Announcement,
    SupportDialog,
    ConfigureSmtp,
    draggable,
    SMSProfile,
    appOutOfOfficeManager: OutOfOfficeManager,
    appSelectListManager: SelectListManager,
    appResetPasswordDlg: ResetPasswordDlg,
    appImportWizard: ImportWizard,
    appInputDlg: InputDlg,
  },
  mixins: [
    codeBaseMixin
  ],
  data() {
    return {
      console,
      copyText,
      document,
      drawer: false,
      page: 'Dashboard',
      showImporter: false,
      notificationCount: 0,
      showResetPassword: false,
      showReports: false,
      showRemoveGmailAccess: false,
      showRemoveZohoAccess: false,
      showRemoveOfficeAccess: false,
      showSelectLists: false,
      selectLists: [],
      showOutOfOfficeManager: false,
      settingOOO: false,
      settingPdfPreview: false,
      settingComs: false,
      showSMSProfile: false,
      changingOrder: false,
      settingStarOnCreate: false,
      settingfollowOnCreate: false,
      settingTaskViewVer: false,
      showSMTPSettings: false,
      showDigest: false,
      showEditQuickTask: false,
      editQuickTask: null,
      editingQuickTask: false,
      qtiFilterString: null,
      qtiMenue: false,
      icons,
      showManageSendAs: false,
      showBilling: false,
      showActiveUsers: false,
      showImpersonationLog: false,
      showAddProfile: false,
      addProfileUsername: null,
      addProfilePassword: null,
      showPassword: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 10 || 'Min 10 characters',
        lower: v => v != null && (/[a-z]/.test(v)) || 'At Least 1 Lower Case Character Is Required',
        upper: v => v != null && (/[A-Z]/.test(v)) || 'At Least 1 Upper Case Character Is Required',
        special: v => v != null && (/[$&+,:;=?@#|'<>.^*()%!-]/.test(v)) || 'At Least 1 Special Character Is Required',
      },
      addProfileReady: null,
      loadingProfile: false,
      showSiteConfig: false,
      showPwResetEmail: false,
      pwResetEmailValue: null,
      settingPwResetEmail: false,
      emailValidation: value => {
        if (!value)
          return 'Invalid Email Address'
        
        if(value.length > 0) {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid Email Address';
        }
      },
      showAutoRead: false,
      zohoCopyTokens: null,
      zohoRemoveTokens: null
    }
  },
  watch: {
    totalNotificationCount(amount) {
      document.title = `Tasklogix${amount ? ` (${amount})` : ''}`;
    },
    pdfPreview(newValue) {
      // this.setPDFPreview(newValue)
    },
    showPwResetEmail(val) {
      this.pwResetEmailValue = this.userInfo.pwResetEmail || null
    },
    userInfo(val) {
      console.log('FIRED', val)
      if (val && val.userID && !val.pwResetEmail) {
        this.showPwResetEmail = true
      }
    }
  },
  methods: {
    
    ...mapActions(['setTheme']),
    
    datasetUpdater() {
      eventBus.$emit('navEvent', 'dsUpdate')
      this.$store.state.datasetUpdaterMap = {
        datasetId: null,
        findMap: {id: null, column: null},
        updateMap: []
      }
    },
    
    rsumUpdate() {
      eventBus.$emit('navEvent', 'dsUpdate')
      
      
      
      this.$store.state.datasetUpdaterMap = {
        "datasetId": 1,
        "findMap": {
          "id": 2,
          "column": "POLICY_NUMBER"
        },
        "updateMap": [
          {
            "id": 5,
            "column": "FULL_STATUS"
          },
          {
            "id": 8,
            "column": "RENEWAL_DATE"
          },
          {
            "id": 9,
            "column": "REVIEW_DATE"
          }
        ]
      }
    },
    
    async removeZohoAccountStart() {
      try {
        this.zohoRemoveTokens = await this.$newReq('GET', `zoho/wh/addresses`)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
      // console.log(process.env.NODE_ENV === "development" ? `https://calvindev.tasklogix.co.za/zoho/wh/${userInfo.entityID}/${userInfo.userID}`)
    },
    
    async copyZohoWebhookURL() {
      try {
        this.zohoCopyTokens = await this.$newReq('GET', `zoho/wh/addresses`)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
      // console.log(process.env.NODE_ENV === "development" ? `https://calvindev.tasklogix.co.za/zoho/wh/${userInfo.entityID}/${userInfo.userID}`)
    },
    
    async removeZohoWebhookURLRun(tokenId) {
      try {
        const res = await this.$newReq('POST', `zoho/user/revoke`, {tokenId})
        if (res?.status !== 'success')
          throw new Error('Error Removing Token')
        window.location.reload()
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
    },
    
    async copyZohoWebhookURLRun(zohoUserId) {
      this.zohoCopyTokens = null
      const params = encodeURIComponent(btoa(JSON.stringify({entityId: this.userInfo.entityID, userId: this.userInfo.userID, zuid:zohoUserId})))
      const baseAddr = process.env.NODE_ENV === "development" ? `https://calvindev.tasklogix.co.za` : 'https://app.tasklogix.co.za'
      const fullUrl = `${baseAddr}/zoho/wh/${params}`
      copyText(document, fullUrl);
      this.$snack.info('Webhook Address Copied')
    },
    
    async linkGoogleSso() {
      try {
        const redirectRoot = serverAddress;
        const addr = await this.$newReq('GET', `sso/google/link/address/${encodeURIComponent(redirectRoot)}`)
        window.location.assign(addr)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
    },
    
    async removeGoogleSso() {
      try {
        await this.$newReq('GET', `sso/google/remove`)
        this.userInfo.googleSSO = false
        this.$snack.info('Changes Saved')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
      
    },
    
    async linkMicrosoftSso() {
      try {
        const redirectRoot = serverAddress;
        const addr = await this.$newReq('GET', `sso/microsoft/link/address/${encodeURIComponent(redirectRoot)}`)
        window.location.assign(addr)
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
      
    },
    
    async removeMicrosoftSso() {
      try {
        await this.$newReq('GET', `sso/microsoft/remove`)
        this.userInfo.microsoftSSO = false
        this.$snack.info('Changes Saved')
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      }
      
    },
    
    async setPwResetEmail() {
      try {
        this.settingPwResetEmail = true
        await this.$newReq('POST', `users/setPWResetEmail`, {pwResetEmail: this.pwResetEmailValue})
        this.$set(this.userInfo, 'pwResetEmail', this.pwResetEmailValue)
        this.$snack.info('Changes Saved')
        this.showPwResetEmail = false;
      } catch (e) {
        console.log(e)
        this.$snack.networkError()
      } finally {
        this.settingPwResetEmail = false
      }
    },
    
    addRepoDocs() {
      this.$getRepoDocs({
        multiple: false,
        allowUserDocs: true,
        noSelect: true
      })
          .catch(e => {
            // Do Nothing
          })
    },
    
    oPlugCopyUrl() {
      const url = `${window.location.protocol}//${window.location.host}/oPlug/${window.location.hostname.split('.').shift()}Manifest.xml`
      this.copyText(document, url);
      this.$snack.info('Autolink Address Copied')
    },
    
    updateQuickTask() {
      this.editingQuickTask = true;
      this.fetch({
        method: 'POST',
        url: `/tasks/quickTask/add/Edit/${this.userInfo.entityID}/${this.userInfo.userID}`,
        body: JSON.stringify(this.editQuickTask)
      })
          .then((data) => {
            arrSplice(this.userInfo.quickTasks, (qt) => qt.id === this.editQuickTask.id)
            this.userInfo.quickTasks.push(this.editQuickTask)
            this.editQuickTask = null;
            this.showEditQuickTask = false;
            this.showSnack('Info', 'Task Shortcut Modified', 'Close', 'primary')
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.addingQuickTask = false;
          })
          .finally(() => {
            this.editingQuickTask = false;
          })
    },
    
    updateO365AutoLink(value) {
      this.$newReq('POST', `users/updateO365AutoLink/${this.userInfo.entityID}/${this.userInfo.userID}/${value ? 1 : 0}`)
          .then(() => {
            this.userInfo.office365Autolink = value ? 1 : 0;
            this.$snack.info('Changes Saved')
          })
          .catch(console.log)
    },
    
    showMailboxManger() {
      eventBus.$emit('navEvent', 'smtpMailboxManager')
    },
    
    showDocRepoManager() {
      eventBus.$emit('navEvent', 'docRepoManager')
    },
    
    showUserGroupManger() {
      eventBus.$emit('navEvent', 'userGroupManger')
    },
    
    showUserManger() {
      eventBus.$emit('navEvent', 'userManger')
    },
    
    updateStarOnCreate(val) {
      this.settingStarOnCreate = true;
      this.fetch({
        method: 'PATCH',
        url: `/localUsers/starOnCreate/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(val)}`
      })
          .then(() => {
            this.settingStarOnCreate = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.userInfo.starOnCreate = 0;
            this.settingStarOnCreate = false;
          });
    },
    
    updateFollowOnCreate(val) {
      this.followStarOnCreate = true;
      this.fetch({
        method: 'PATCH',
        url: `/localUsers/followOnCreate/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(val)}`
      })
          .then(() => {
            this.followStarOnCreate = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.userInfo.followOnCreate = 0;
            this.followStarOnCreate = false;
          });
    },
    
    updateTaskViewVer(val) {
      this.settingTaskViewVer = true;
      this.fetch({
        method: 'PATCH',
        url: `/localUsers/taskViewVer/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(val)}`
      })
          .then(() => {
            this.settingTaskViewVer = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.userInfo.taskView = 0;
            this.settingTaskViewVer = false;
          });
    },
    
    removeQuick(qTask) {
      this.changingOrder = true;
      this.fetch({
        method: 'POST',
        url: `/tasks/quickTask/remove/${this.userInfo.entityID}/${this.userInfo.userID}/${qTask.id}`
      })
          .then(() => {
            arrSplice(this.userInfo.quickTasks, (obj) => obj.id === qTask.id);
            this.showSnack('Info', 'Quick Task Removed', 'Close', 'primary')
            this.changingOrder = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.changingOrder = false;
          });
    },
    
    log(event) {
      
      let tArr = [];
      
      Object.assign(tArr, this.sortedQuickTasks)
      
      tArr.splice(event.moved.oldIndex, 1, null)
      
      if (event.moved.oldIndex > event.moved.newIndex) {
        tArr.splice(event.moved.newIndex, 0, event.moved.element)
      } else {
        tArr.splice(event.moved.newIndex + 1, 0, event.moved.element)
      }
      
      tArr = tArr.filter(obj => obj !== null);
      
      let updateBody = tArr
          .map((obj, index) => {
            let tConfig = {}
            Object.assign(tConfig, obj.config)
            tConfig.order = index
            return {id: obj.id, config: tConfig}
          });
      this.changingOrder = true;
      this.fetch({
        method: 'POST',
        url: `/tasks/quickTask/order/update/${this.userInfo.entityID}/${this.userInfo.userID}`,
        body: JSON.stringify(updateBody)
      })
          .then(() => {
            this.userInfo.quickTasks.forEach(qt => {
              qt.config.order = updateBody.filter(obj => obj.id === qt.id).map(obj => {
                return obj.config.order
              }).pop()
            });
            this.showSnack('Info', 'Order Updated', 'Close', 'primary')
            this.changingOrder = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.changingOrder = false;
          });
      
    },
    
    quickTaskRun(workflow, folder) {
      // TODO FILTER and load quick tasks from user info
      eventBus.$emit('quickTask', {workflow: workflow, folder: folder})
      
    },
    
    resetSyncStatus() {
      eventBus.$emit('resetSyncStat')
    },
    
    setOutOfOffice(value) {
      this.settingOOO = true;
      this.fetch({
        method: 'GET',
        url: `/localUsers/OOO/setUser/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(!this.intToBool(this.userInfo.outOfOffice))}`
      })
          .then(() => {
            this.userInfo.outOfOffice = this.boolToInt(!this.intToBool(this.userInfo.outOfOffice));
            eventBus.$emit('OOOSet', this.userInfo.outOfOffice)
            this.settingOOO = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            this.settingOOO = false;
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.$refs.outOfOfficeSwitch.value = this.intToBool(this.userInfo.outOfOffice)
          })
    },
    
    setPDFPreview(value) {
      this.settingPdfPreview = true;
      this.fetch({
        method: 'POST',
        url: `/users/setPdfPreview/${this.userInfo.entityID}/${this.userInfo.userID}/${value ? 1 : 0}`
      })
          .then(() => {
            this.$store.state.userInfo.userInfo.pdfPreview = value ? 1 : 0
            this.settingPdfPreview = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            this.settingPdfPreview = false;
            console.log(e);
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.$store.state.userInfo.userInfo.pdfPreview = !value ? 1 : 0
          })
    },
    oldFieldSetManager() {
      eventBus.$emit('showFieldSetEditor')
    },
    showOOOManager() {
      this.drawer = false;
      this.showOutOfOfficeManager = true;
    },
    
    showSelectList() {
      this.drawer = false;
      this.showSelectLists = true;
    },
    
    removeGmailAccess() {
      this.fetch({method: 'GET', url: `/gmail/auth/LogoutandRemoveAccess/${this.userInfo.userID}`})
          .then((data) => {
            eventBus.$emit('gmailAccountRemoved');
            this.showSnack('Info', 'Gmail Account Removed', 'Close', 'primary');
            this.showRemoveGmailAccess = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e)
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.showRemoveGmailAccess = false;
          })
    },
    
    removeOfficeAccess() {
      this.fetch({method: 'GET', url: `/office/auth/removeToken/${this.userInfo.userID}`})
          .then((data) => {
            eventBus.$emit('officeAccountRemoved');
            this.showSnack('Info', 'Office Account Removed', 'Close', 'primary');
            this.showRemoveOfficeAccess = false;
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e)
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.showRemoveOfficeAccess = false;
          })
    },
    
    resetPassword(password) {
      if (password != null && password != '') {
        
        this.showResetPassword = false;
        
        this.fetch({
          method: 'PATCH',
          url: '/localUsers/setPassword/' + this.userInfo.entityID + '/' + this.userInfo.userID,
          body: JSON.stringify({password: password, username: this.userInfo.username})
        })
            .then(() => {
              this.showSnack('Info', 'Password Has Been Changed', 'Close', 'primary')
            })
            .catch((e) => {
              // eslint-disable-next-line
              console.log(e)
              this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
            })
        
        // showSetPassword
      } else {
        this.showSnack('Error', 'Password Can Not Be Blank', 'Close', 'red')
      }
    },
    
    showFieldSetEditor() {
      this.drawer = false;
      eventBus.$emit('showFieldSetEditor', true);
    },
    
    showGmailMailbox() {
      this.drawer = false;
      eventBus.$emit('showGroupMailboxManager', true);
    },
    
    showSignatures() {
      this.drawer = false;
      eventBus.$emit('signatureManager', true);
    },
    nav(navTo) {
      this.drawer = false;
      eventBus.$emit('navEvent', navTo);
    },
    async logOff() {
      // const rememberMe = await dbGlobalMethods.addConfigValue('autoLogin', null)
      
      this.$store.state.autoLogin = false
      
      this.fetch({method: 'DELETE', url: `/login/logout`})
          .then(() => {
            eventBus.$emit('showHideNav', false);
          })
          .catch((e) => {
            // eslint-disable-next-line
            console.log(e)
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
          });
    },
    notificationCountUpdate(amount) {
      this.notificationCount = amount;
    },
    navEvent(navTo) {
      switch (navTo) {
        case 'gmail': {
          this.page = 'Gmail';
          break;
        }
        case 'office365': {
          this.page = 'Office 365';
          break;
        }
        case 'dashboard': {
          this.page = 'Dashboard';
          eventBus.$emit('DashboardShown');
          break;
        }
        case 'tasks': {
          this.page = 'Tasks';
          eventBus.$emit('TasksScreenShown');
          break;
        }
      }
    },
    
    async gotoProfile(profile) {
      if (!profile.active)
        try {
        
          window.location.assign(serverAddress + `/users/switchProfile/${profile.userId}/${token()}/${window.location.host}`)
        
          // this.loadingProfile = true;
          // const {token, exp} = await this.$newReq('POST', `users/switchProfile`, profile)
          // console.log(window.location)
          //
          // var currentUrl = window.location.href;
          // var url = new URL(currentUrl);
          //
          // // Set new query parameters
          // url.searchParams.set('user_key', userKey);
          // url.searchParams.set('token', token);
          // url.searchParams.set('exp', exp);
          //
          // // Reload the page with the new URL
          // window.location.href = url.href;
          
          this.showAddProfile = false
        } catch (e) {
          console.log(e)
        } finally {
          this.loadingProfile = false;
        }
    },
    
    async removeProfile(profile) {
      try {
        this.loadingProfile = true;
        await this.$newReq('POST', `users/removeProfile`, profile)
        arrSplice(this.userInfo.userProfiles, pro => pro.userId === profile.userId)
        this.showAddProfile = false
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingProfile = false;
      }
    },
    
    async addProfile() {
      try {
        this.loadingProfile = true;
        const res = await this.$newReq('POST', `users/addProfile`, {
          from: this.profiles.find(pro => pro.active),
          to: {
            username: this.addProfileUsername,
            password: this.addProfilePassword
          }
        })
        
        if (res.error)
          return this.$snack.error(res.message)
        
        
        this.$set(this.userInfo, "userProfiles", res)
        this.showAddProfile = false
        
      } catch (e) {
        console.log(e)
      } finally {
        this.loadingProfile = false;
      }
    }
  },
  
  created() {
    eventBus.$on('notificationCountUpdate', this.notificationCountUpdate);
    
    eventBus.$on('navEvent', this.navEvent)
  },
  beforeDestroy() {
    eventBus.$off('notificationCountUpdate', this.notificationCountUpdate);
    eventBus.$off('navEvent', this.navEvent)
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo', 'softBlock', 'masterAdmin']),
    ...mapGetters('chat', ['totalUnreadChats']),
    
    isAdmin() {
      return this.userInfo.tasklogixAdmin || this.userInfo.username.match(/^tlx@/gi)
    },
    
    totalNotificationCount() {
      
      if (this.userInfo && this.userInfo.contactsDisabled)
        return this.notificationCount
      return this.notificationCount + this.totalUnreadChats
    },
    
    
    unreadChatMessages() {
      return this.totalUnreadChats
    },
    
    billingManager() {
      return billingManager
    },
    
    
    starOnCreate: {
      get() {
        return this.intToBool(this.userInfo.starOnCreate)
      },
      set(val) {
        this.userInfo.starOnCreate = this.boolToInt(val);
        this.updateStarOnCreate(val);
      }
    },
    
    followOnCreate: {
      get() {
        return this.intToBool(this.userInfo.followOnCreate)
      },
      set(val) {
        this.userInfo.followOnCreate = this.boolToInt(val);
        this.updateFollowOnCreate(val);
      }
    },
    
    taskViewVer: {
      get() {
        return this.intToBool(this.userInfo.taskView)
      },
      set(val) {
        this.userInfo.taskView = this.boolToInt(val);
        this.updateTaskViewVer(val);
      }
    },
    
    
    sortedQuickTasks() {
      return this.userInfo.quickTasks.filter(() => true).sort((a, b) => a['config']['order'] < b['config']['order'] ? -1 : 1);
    },
    
    outOfOffice: {
      get() {
        if (typeof this.userInfo.outOfOffice != 'undefined') {
          return this.intToBool(this.userInfo.outOfOffice)
        } else {
          return false;
        }
      },
      set(value) {
        this.setOutOfOffice(value)
      }
    },
    
    pdfPreview: {
      get() {
        return this.$store.state.userInfo.userInfo?.pdfPreview
      },
      set(val) {
        this.$store.state.userInfo.userInfo.pdfPreview = val ? 1 : 0
        this.setPDFPreview(val)
      }
    },
    
    profiles() {
      
      if (!this.userInfo || !this.userInfo.userProfiles || !Array.isArray(this.userInfo.userProfiles))
        return [];
      
      let profiles = [...this.userInfo.userProfiles]
      
      if (!profiles.find(pro => pro.userId === this.userInfo.userID)) {
        profiles.push({
          userId: this.userInfo.userID,
          username: this.userInfo.username,
          userName: `${this.userInfo.name} ${this.userInfo.surname}`.trim(),
          entityId: this.userInfo.entityID,
          entityName: this.userInfo.entityDesc,
          userDisabled: 0,
          entityDisabled: 0
        })
      }
      
      profiles = profiles.map(pro => {
        return {...pro, active: pro.userId === this.userInfo.userID}
      })
      
      profiles.sort((a, b) => {
        if (a.active)
          return -1
        if (b.active)
          return 1
        return a.userName > b.userName ? 1 : -1
      }).filter(profile => !(profile.userDisabled || profile.entityDisabled))
      
      return profiles
    }
  }
}
</script>

<style scoped>

.nav-item {
  cursor: pointer;
}

/*.nav-item:hover {*/
/*border-radius: 2px;*/
/*background: #00aa9c;*/
/*}*/

.reflow-image {
  width: 100%;
  height: auto;
  margin-top: auto;
}


</style>
